module.exports = {
  siteTitle: 'Kam Chauhan', // <title>
  manifestName: 'Kam Chauhan',
  manifestShortName: 'Kam Chauhan', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#663399',
  manifestThemeColor: '#663399',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Kam Chauhan',
  subHeading: 'SUPPORT . LEARN . DEVELOP . GROW',

  // social
  socialLinks: [
    {
      icon: 'fa-instagram',
      name: 'Instagram',
      url: 'https://www.instagram.com/kamchauhan.uk/',
    },
    {
      icon: 'fa-facebook-f',
      name: 'Facebook',
      url: 'https://www.facebook.com/kamchauhan.UK/',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/kam-chauhan/',
    }
  ],
  email: 'kam@kamchauhan.co.uk',
  phone: '07760 166 596',
  address: 'Milton Keynes, Buckinghamshire',
};
